import api from '@motionelements/core/src/api/base-api-v2';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';

const state = () => ({
  list: [],
  loading: false,
  isLoaded: false,
  externalTools: [
      'business_illustration',
      'image_to_video',
      'text_to_illustration',
      'text_to_speech',
      'text_to_video',
  ],
});

const getters = {
  aiToolsReleased(state) {
    return state.list.filter(({ released }) => released);
  },
  aiToolModels(state) {
    // eslint-disable-next-line
    return (toolId) => {
      const tool = state.list.find(({ id }) => id === toolId);
      return tool?.models?.map(({ id, name, recommended }) => ({
        id,
        value: id,
        label: name,
        recommended,
      })) || [];
    };
  },
};

const actions = {
  async getAiTools({ commit }, params) {
    commit('setLoading', true);
    return api.get('/v3/tools', { params })
      .then((response) => {
        commit('setAiTools', response.data.data);
        commit('setIsLoaded', true);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setAiTools(state, array) {
    state.list = array;
  },
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    ...mutations,
    ...loadingMutation,
  },
};
